import React from "react"

type IconProps = { className?: string }

/** 「気になる」の星。filled=true で塗り、false でアウトライン */
export function FavoriteStarIcon({
    className,
    filled,
}: IconProps & { filled: boolean }) {
    return (
        <svg
            className={className}
            viewBox="0 0 15 15"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <path
                d="M10.0979 4.25117L14.1614 4.85065C14.4979 4.89872 14.7806 5.13625 14.8881 5.46143C14.9955 5.78945 14.9079 6.14574 14.6647 6.38893L11.7182 9.27886L12.4138 13.4243C12.4704 13.7636 12.3318 14.1086 12.0491 14.3094C11.7691 14.5101 11.3987 14.5356 11.0961 14.3744L7.46532 12.4374L3.83736 14.3744C3.53197 14.5356 3.16153 14.5101 2.88159 14.3094C2.60165 14.1086 2.46026 13.7636 2.51964 13.4243L3.21526 9.27886L0.268211 6.38893C0.024744 6.14574 -0.0617843 5.78945 0.0451035 5.46143C0.151709 5.13625 0.433632 4.89872 0.772676 4.85065L4.83272 4.25117L6.65377 0.509247C6.80364 0.197745 7.12034 0 7.46532 0C7.81313 0 8.12984 0.197745 8.27971 0.509247L10.0979 4.25117Z"
                fill={filled ? "currentColor" : "none"}
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinejoin="round"
            />
        </svg>
    )
}

/** 検索(虫眼鏡)アイコン */
export function SearchIcon({ className }: IconProps) {
    return (
        <svg
            className={className}
            viewBox="0 0 16 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <path d="M15.6343 13.8656L11.8937 10.125C12.7443 8.86218 13.164 7.28436 12.9393 5.60311C12.5562 2.74343 10.2125 0.416239 7.34996 0.053833C3.09403 -0.484698 -0.484724 3.09405 0.0538389 7.34999C0.416339 10.2137 2.74384 12.5594 5.60384 12.9406C7.28509 13.1653 8.86321 12.7457 10.1257 11.895L13.8663 15.6356C14.3545 16.1237 15.146 16.1237 15.6342 15.6356C16.1218 15.1469 16.1218 14.3531 15.6343 13.8656ZM2.47184 6.49999C2.47184 4.29436 4.26621 2.49999 6.47184 2.49999C8.67746 2.49999 10.4718 4.29436 10.4718 6.49999C10.4718 8.70561 8.67746 10.5 6.47184 10.5C4.26621 10.5 2.47184 8.70624 2.47184 6.49999Z" />
        </svg>
    )
}
